import { SESSION_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TSessionSelector, TEqualityFunction } from '../types';

export const useSessionSelector = <TSelected>(
    selector: TSessionSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>
) => {
    return useCustomSelector<TSelected, typeof SESSION_REDUCER>(SESSION_REDUCER, selector, equalityFn);
};
